import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import BaseLoading from './BaseLoading';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./api/i18n"

ReactDOM.render(
    <React.Suspense fallback={<BaseLoading/>}>
        <App/>
    </React.Suspense>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
